import types from './InventoryItemStatusType';

/**
 * Подписи статусов оборудования. Ключ — числовое значение статуса.
 */
export default class InventoryItemStatusTitle {
    static [types.IN_STOCK] = 'На складе';
    static [types.RESERVED] = 'Резерв';
    static [types.IN_USE] = 'В эксплуатации';
    static [types.IN_REPAIR] = 'В ремонте';
    static [types.BROKEN] = 'Неисправно';
    static [types.DECOMMISSIONED] = 'Списано';
}
